webpackJsonp([138843065278233],{

/***/ 730:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/it/BCJ/","langKey":"it"}}

/***/ })

});


// WEBPACK FOOTER //
// path---it-bcj-2ccdddf196aab5c550d7.js